@if (viewingClient && finishedLoading) {
    <h1 mat-dialog-title>Client Information</h1>
}

@if (editingClient) {
    <h1 mat-dialog-title>Edit Client</h1>
}

@if (mergingClient) {
    <h1 mat-dialog-title>Merge Client</h1>
}

@if (mergeClientConfirm) {
    <h1 mat-dialog-title>Confirm Merge</h1>
}

<mat-dialog-content>
    @if (viewingClient && finishedLoading)
    {
        <h5>Full Name: {{client().clientFullName}}</h5>
        <br>
        <h5>Display Name: {{client().clientDisplayName}}</h5>
        <br>
        <h5>Short Name: {{client().clientShortName}}</h5>
        <br>
        <h5>Integration Abbreviated Name: {{client().clientAbbreviatedName}}</h5>
        <br>
        <h5>CompenSafe Internal Name: {{client().compensafeInternalName}}</h5>
        <br>
        <h5>Aliases: {{client().clientInformationAliases}}</h5>
        <br>
        <h5>Display In UI: {{client().uiDisplay}}</h5>
        <br>

        <button matButton="elevated" (click)="setEditing()" [disabled]="!checkAccess(['LOSTalker.Admin'])">
            Edit
        </button>

        <button style="float: left;" matButton="elevated" (click)="setMerging()"
            [disabled]="!checkAccess(['LOSTalker.Admin']) || !clientsLoaded">
            Merge
        </button>

        @if (!clientInformation)
        {
            <button style="float: left;"
                [disabled]="addingClientInfo || !checkAccess(['LOSTalker.Admin'])" matButton="elevated"
                (click)="addClientInformation()">
                Populate Client Information
            </button>
        }

        <button style="float: right;" matButton="elevated" matDialogClose>
            Close
        </button>
    }

    @if (editingClient)
    {
        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Client Full Name</mat-label>
            <input matInput [(ngModel)]="client().clientFullName">
        </mat-form-field>
        <br>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Client Short Name</mat-label>
            <input matInput [(ngModel)]="client().clientShortName">
        </mat-form-field>
        <br>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Client Display Name</mat-label>
            <input matInput [(ngModel)]="client().clientDisplayName">
        </mat-form-field>
        <br>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Integration Abbreviated Name</mat-label>
            <input matInput [(ngModel)]="client().clientAbbreviatedName">
        </mat-form-field>
        <br>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>IC Internal Name</mat-label>
            <input matInput [(ngModel)]="client().compensafeInternalName">
        </mat-form-field>
        <br>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Aliases</mat-label>
            <input matInput [(ngModel)]="client().clientInformationAliases" />
        </mat-form-field>
        <br>

        <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Parent Company</mat-label>
            <input matInput [(ngModel)]="client().parentCompany" />
        </mat-form-field>
        <br>

        <div class="switch-container">
            <app-lt-switch [onLabel]="'Display In UI'" [offLabel]="'Hide In UI'" [(ngModel)]="client().uiDisplay"></app-lt-switch>
        </div>
        <br>

        <button matButton="elevated" matDialogClose (click)="updateClient()"
            [disabled]="!checkAccess(['LOSTalker.Admin'])">
            Save Changes
        </button>
        <button matButton="elevated" (click)="cancel()" style="float: right;">
            Back
        </button>
    }

    @if (mergingClient && clientsLoaded)
    {
        <div>
            <br/>
            <div class="client-box">

                <h5>Name: {{client().clientDisplayName}}</h5>

                <h5>Integration Abbreviated Name: {{client().clientAbbreviatedName}}</h5>

                <h5>CompenSafe Internal Name: {{client().compensafeInternalName}}</h5>

                <h6>Integrations: </h6>

                @for (integration of integrations(); track integration) {
                    <h6 style="float: left; padding-right: 10px; padding-left: 10px;">{{integration.name}}</h6>
                }

            </div>
            <div class="center">
                <br />
                <br />
                <br />
                <h2>Merge into</h2>
                <br />
                <br />
            </div>
            <div class="client">

                <mat-form-field appearance="fill" style="min-width: 325px;">
                    <mat-label>Select Client To Merge</mat-label>
                    <input type="text" matInput [matAutocomplete]="auto" [formControl]="myControl">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                        (optionSelected)="selectMergeClient($event.option.value)" [displayWith]="displayClientName">

                        @for (option of filteredOptions | async; track option) {
                            <mat-option [value]="option">
                                {{option.clientDisplayName}}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                @if (mergeClientSelected)
                {
                    <div class="client-box">
                        <h5>Name: {{mergeClient.clientDisplayName}}</h5>

                        <h5>Integration Abbreviated Name: {{mergeClient.clientAbbreviatedName}}</h5>

                        <h5>CompenSafe Internal Name: {{mergeClient.compensafeInternalName}}</h5>

                        <h6>Integrations: </h6>


                        @for (integration of mergeClientIntegrations; track integration) {
                            <h6 style="float: left; padding-right: 10px; padding-left: 10px;">{{integration.name}}</h6>
                        }
                    </div>
                }

                <br>
                <br>
            </div>
        </div>

        <button matButton="elevated" (click)="submit()"
            [disabled]="!mergeClientSelected || !checkAccess(['LOSTalker.Admin'])">
            Submit
        </button>

        <button matButton="elevated" (click)="cancel()" style="float: right;">
            Back
        </button>
    }

    @if (mergeClientConfirm)
    {
        <div>

            <h4>The client {{client().clientDisplayName}} will be <b>deleted</b>, <br>
                and all integrations will be moved to <br>
                {{mergeClient.clientDisplayName}}, resulting in this client.</h4>

            <br />
            <br />

            <div class="client-box">

                <h5>Name: {{mergeClient.clientDisplayName}}</h5>

                <h5>Integration Abbreviated Name: {{mergeClient.clientAbbreviatedName}}</h5>

                <h5>CompenSafe Internal Name: {{mergeClient.compensafeInternalName}}</h5>

                <h6>Integrations: </h6>

                @for (integration of mergeClientIntegrations; track integration) {
                    <h6 style="float: left; padding-right: 10px; padding-left: 10px;">{{integration.name}}</h6>
                }

                @for (integration of integrations(); track integration) {
                    <h6 style="float: left; padding-right: 10px; padding-left: 10px;">{{integration.name}}</h6>
                }

            </div>

            <br />
            <br />
            <br />

            <h4>Are you sure you wish to continue?</h4>

            <br />
            <br />

        </div>

        <button matButton="elevated" matDialogClose (click)="mergeClients()"
            [disabled]="!mergeClientSelected || !checkAccess(['LOSTalker.Admin'])">
            Submit
        </button>

        <button matButton="elevated" (click)="cancel()" style="float: right;">
            Back
        </button>
    }
</mat-dialog-content>
